import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface BenefitsSectionProps {}

const BenefitItem: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="flex gap-2">
    <img
      src="/assets/images/auth/icons/Checkmark.png"
      alt="Checkmark"
      className="object-contain shrink-0 my-auto aspect-square w-[18px]"
    />
    <span className="flex-auto">{children}</span>
  </div>
);

export const BenefitsSection: React.FC<BenefitsSectionProps> = () => {
  return (
    <section className="text-base leading-none text-stone-50">
      {/* ✅ Centered heading */}
      <h3 className="w-full text-center mt-8 text-lg font-bold text-white underline">
        Free Platform Benefits
      </h3>

      <div className="flex flex-wrap gap-6 justify-center mt-5 max-w-full w-[658px] mx-auto">
        <BenefitItem>Complete platform access from day one</BenefitItem>
        <BenefitItem>Upgrade individual features as needed</BenefitItem>
      </div>

      <div className="flex flex-wrap gap-5 justify-center mt-5">
        <BenefitItem>No time limits on free features</BenefitItem>
        <BenefitItem>Full data export option</BenefitItem>
        <BenefitItem>Personal onboarding available</BenefitItem>
      </div>
    </section>
  );
};
